module.exports = __webpack_public_path__ + "static/coffeetalk3-8a66c54d85fbfd43994399b7dfbe5336.webp";